<template>
  <section>
    <v-dialog v-model="show" fullscreen>
      <v-card flat>
        <v-container>
          <div class="dialog-toolbar">
            <v-col cols="9" md="11">
              <h3>Vista previa</h3>
            </v-col>
            <v-col cols="1" md="1" class="close-icon-container">
              <v-icon @click="$emit('close-dialog')" style="transform: translateX(-15px)">close</v-icon>
            </v-col>
          </div>
          <div style="height: 50px;"></div>
          <v-row>
            <v-col cols="12" style="padding-bottom:0">
              <v-img
                v-if="file.mimetype != 'application/pdf'"
                :src="getFile(file.file)"
              />
              <div v-else class="pdf-preview-container">
                <iframe
                    :src="getFile(file.file)"
                    class="pdf-preview"
                    style="cursor:zoom-in"
                    ref="pdfprev">
                </iframe>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
export default {
  props: {
    show: Boolean,
    file: Object
  },
  data () {
    return {
      token: null
    }
  },
  created () {
    const user = JSON.parse(localStorage.getItem('user'))
    this.token = user.stsTokenManager.accessToken
  },
  methods: {
    getFile (url) {
      return url + '?token=' + this.token
    }
  }
}
</script>
<style scoped>
@media(max-width:959px){
  .pdf-preview {
    height: 95vh;
    width: 100%;
    border: none;
    margin-top: -56px;
  }
}
@media(min-width:960px){
  .pdf-preview {
    height: 640px;
    width: 100%;
    border: none;
    margin-top: -56px;
  }
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
}
.pdf-preview-container {
    height: 100%;
    width: 100%;
    overflow-y: hidden;
}
</style>
